<template>
	<div
			class="language"
			:class="{ active: languageMenuOpen }"
			@click="languageMenuOpen = !languageMenuOpen"
	>
		<span name="language">{{ currentLanguageCode }}</span>
		<ul>
			<li v-for="language in languagesToSelect">
				<a @click.prevent="languageSelected(language)">
					{{ changeIso(language) }}
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
import { UI_LANGUAGES_SET_CURRENT_LANGUAGE } from 'store/modules/uiLanguages'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'LanguageSelect',
  data() {
    return {
      languageMenuOpen: false,
      languagesMap: {
        'ces': 'CS',
        'slk': 'SK',
        'eng': 'EN',
        'deu': 'DE'
      }
    }
  },
  created() {
    this.initUILanguage()
  },
  computed: {
    languagesToSelect() {
      const languagesToSelect = {}
      Object.assign(languagesToSelect, this.$language.available)
      delete languagesToSelect[this.changeIso(this.$language.current)]

      return languagesToSelect
    },
    currentLanguageCode() {
      return this.changeIso(this.$language.current)
    }
  },
  methods: {
    ...mapActions([
      'getEnums'
    ]),
    languageSelected(language) {
      this.$language.current = language
      this.commitLangugageToStore(language)
    },
    changeIso(value) {
      return this.languagesMap[value]
    },
    commitLangugageToStore(language) {
      this.$store.commit({
        type: UI_LANGUAGES_SET_CURRENT_LANGUAGE,
        value: language,
        ids: localStorage.ui_languages_id
      })
    },
    initUILanguage() {
      moment.locale(this.$language.current)
    }
  },
  watch: {
    currentLanguageCode() {
      this.getEnums()
    }
  }
}
</script>
